import React from 'react'
import get from 'lodash/get'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import CoachCardSm from 'components/coach-card-small'
import { useStyles, Header, HelperText, NextButton } from '../styles'
import { useWizardFormContext } from 'components/wizard-form/context'
import { Questionnaire } from '../constants'

const stepsMapper = {
  'Who is looking for coaching?':
    Questionnaire.WHO_IS_LOOKING_FOR_COACHING.stepNumber,
  'What is your child first name?': Questionnaire.CHILD_FIRST_NAME.stepNumber,
  'What is your child last name?': Questionnaire.CHILD_LAST_NAME.stepNumber,
  'What is your availability?': Questionnaire.AVAILABILITY.stepNumber,
  'What is your reason for wanting golf lessons?':
    Questionnaire.REASON.stepNumber,
  'Have you ever taken a lesson before?': Questionnaire.EXPERIENCE.stepNumber,
  'What do you normally shoot?': Questionnaire.SHOOT.stepNumber,
  'How soon are you looking to improve?':
    Questionnaire.TIME_TO_IMPROVE.stepNumber,
}

const Summary = ({ coach }) => {
  const { setActiveStepNumber, formValues, advance } = useWizardFormContext()
  const questionnaire = get(formValues, 'questionnaire')
  const classes = useStyles()

  return (
    <>
      <Grid container spacing={1}>
        <Grid item md={8} xs={12}>
          <Header variant="h4">Summary</Header>
          <HelperText variant="body1">
            Check over your answers and make sure they are all correct.
          </HelperText>
        </Grid>
        <Grid item md={4} xs={12} style={{ marginLeft: 'auto' }}>
          <CoachCardSm coach={coach} />
        </Grid>
      </Grid>
      <Grid container item>
        <Grid item md={7} xs={12}>
          <List>
            <ListItem style={{ paddingLeft: 0, paddingTop: '16px' }}>
              <Typography variant="body1">
                What are your contact details?
              </Typography>
              <ListItemSecondaryAction>
                <IconButton
                  color="default"
                  edge="end"
                  onClick={() => setActiveStepNumber(3)}
                  style={{ padding: 0 }}
                >
                  <EditIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Typography variant="body2" color="textSecondary">
              <span className={classes.answersList}>
                {formValues.firstName} {formValues.lastName}
              </span>
              <span className={classes.answersList}>
                {formValues.phoneNumber}
              </span>
              <span className={classes.answersList}>{formValues.email}</span>
            </Typography>
            {questionnaire &&
              questionnaire.map((question, index) => {
                if (question?.answer !== '' && !question?.answer) return null
                return (
                  <div key={index}>
                    <ListItem style={{ paddingLeft: 0, paddingTop: '16px' }}>
                      <Typography variant="body1">
                        {question.question}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{
                          paddingLeft: '16px',
                          textTransform: 'capitalize',
                        }}
                      >
                        {typeof question.answer === 'string'
                          ? question.answer
                          : null}
                        .
                      </Typography>
                      <ListItemSecondaryAction>
                        <IconButton
                          color="default"
                          edge="end"
                          onClick={() =>
                            // stepsMapper uses a 1-based index
                            setActiveStepNumber(
                              stepsMapper[question.question] - 1,
                            )
                          }
                          style={{ padding: 0 }}
                        >
                          <EditIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{
                        textTransform: 'capitalize',
                      }}
                    >
                      {typeof question.answer !== 'string' && question.answer
                        ? question.answer.map(
                          (item, index) =>
                            item && (
                              <span className={classes.answersList} key={index}>
                                {item}
                              </span>
                            ),
                        )
                        : null}
                    </Typography>
                  </div>
                )
              })}
          </List>
          <NextButton variant="contained" color="primary" onClick={advance}>
            Send to Coach
          </NextButton>
        </Grid>
      </Grid>
    </>
  )
}

export default Summary
